import React, { forwardRef, Fragment } from 'react';
import { FormatCurrency } from "../GlobalScript";
import Table from 'react-bootstrap/Table';

const PrintableOrder = forwardRef(({ selectedItems, total, orderName, orderType, kCode, shipTo, shipMethod, partsTotal, accTotal, otherTotal, estFreight, estHandling, estSpecialFee, grandTotal, showPrice, orderID }, ref) => {

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                    </div>
                );
        }
    };

    return (
        <div className="print-container" ref={ref}>
            <Table>
                <tbody>
                    <tr>
                        <td className="text-center">
                            <h3>Order Name: {orderName}</h3>
                        </td>
                        <td className="text-center">
                            <h3>Order Type: {orderType}</h3>
                        </td>
                        <td className="text-center">
                            <h3>K-Code: {kCode ? kCode : 'NONE'}</h3>
                        </td>
                    </tr>
                    {orderID &&
                        <tr>
                            <td align="center" colSpan="3" className="text-center">
                                <h3>Order Number: {orderID}</h3>
                            </td>
                        </tr>    
                    }
                </tbody>
            </Table>

            <div className="table-legend">
                <div className="text-center mt-2 align-content-end">
                    <div className="table-legend-section">
                        <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                        <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                        <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                    </div>

                    <div className="table-legend-section">
                        <span className="icons-row"><div className={`status-icon green-icon`}></div> Available</span>
                        <span className="icons-row"><div className={`status-icon yellow-icon`}></div> Partial</span>
                        <span className="icons-row"><div className={`status-icon red-icon`}></div> Unavailable</span>
                    </div>

                    <div className="table-legend-section">
                        <span className="svg-holder"><img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk" /> Pkg Qty</span>
                        <span className="svg-holder"><img src="../../../Images/substitute.svg" alt="" className="" /> Substitute</span>
                        <span className="svg-holder"><img className="" src={"../../../Images/LTL.svg"} alt="LTL" /> LTL</span>
                        <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                    </div>
                </div>
            </div>

            <div className="order-table">
                <Table className="compact-table">
                    <thead>
                        <tr>
                            <th>ITEM NO</th>
                            <th>DESCRIPTION</th>
                            <th>TYPE</th>
                            <th width="8%">ORDER <br /> QTY</th>
                            <th>AVAIL <br /> QTY</th>
                            <th>CA (L)</th>
                            <th>KY (R)</th>
                            <th>TX (D)</th>
                            <th width="10%">MEMO</th>
                            <th>EXC / RTN</th>
                            <th>PKG <br /> QTY</th>
                            <th>BO <br /> QTY</th>
                            <th>UNIT <br /> PRICE</th>
                            <th>ITEM <br /> TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from(selectedItems.values()).map((d, index) => (
                            <Fragment key={"sku" + index.toString()}>
                                {d.item.factorAlert &&
                                    <tr className="alerts-compact">
                                        <td colSpan="15">
                                            <div className="icons-row alert-noti asterisk-noti text-left">
                                                <span className="svg-holder small-svg">
                                                    <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                </span>

                                                <p className="mb-0">This item's quantity has been increased to a factor of the package quantity.</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {d.item.ltl &&
                                    <tr className="alerts-compact">
                                        <td colSpan="15">
                                            <div className="icons-row alert-noti ltl-noti text-left">
                                                <span className="svg-holder small-svg">
                                                    <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                </span>

                                                <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {d.item.substitutedSKU !== '' &&
                                    <tr className="alerts-compact">
                                        <td colSpan="15">
                                            <div className="icons-row substitute-noti alert-noti text-left">
                                                <span className="svg-holder small-svg">
                                                    <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                </span>

                                                <p className="mb-0">Item No: {d.item.substitutedSKU} is substituted by Item No: {d.item.distitemNbr}</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {d.item.pk &&
                                    <tr className="alerts-compact">
                                        <td colSpan="15">
                                            <div className="icons-row alert-noti bo-noti text-left">
                                                <span className="svg-holder small-svg">
                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                </span>

                                                <p className="mb-0">Package built to order</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                {d.item.boCnt > 0 &&
                                    <tr className="alerts-compact">
                                        <td colSpan="15">
                                            <div className="icons-row alert-noti bo-noti text-left">
                                                <span className="svg-holder small-svg">
                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                </span>

                                                <p className="mb-0">This item is backordered</p>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                <tr className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red-border min-border' : ''}>
                                    <td className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red' : ''}>
                                        {d.item.distitemNbr}
                                    </td>
                                    <td className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red' : ''}>
                                        {d.addInfo && d.addInfo.itemDesc}
                                    </td>
                                    <td>
                                        <span className="svg-holder small-svg">
                                            <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} />
                                        </span>
                                    </td>
                                    <td>{d.item.qty + d.item.boCnt}</td>
                                    <td>{d.item.qty}</td>
                                    <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                    <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                    <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                    <td>{d.item.vin}</td>
                                    <td>{d.addInfo && d.addInfo.eligibleExchangeReturn ? d.addInfo.eligibleExchangeReturn : ''}</td>
                                    <td>{d.item.whslePkgCnt}</td>
                                    <td>{d.item.boCnt}</td>
                                    <td>{FormatCurrency(d.item.dealerPrice)}</td>
                                    <td>{FormatCurrency(d.item.dealerPrice * (d.item.qty + d.item.boCnt))}</td>
                                </tr>
                            </Fragment>
                        ))}

                        <tr>
                            <td colSpan={"12"}></td>
                            <td className="bold">Total:</td>
                            <td className="bold">
                                {FormatCurrency(total)}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>

            {shipTo &&
                <Table>
                    <tbody>
                        <tr>
                            <td>
                                <p className="bold">Ship To:</p>
                                <p>
                                    {shipTo.firstName} <br />
                                    {shipTo.address} <br />
                                    {shipTo.cityStateZip} <br />
                                    {shipTo.countryCode}
                                </p>
                                {shipMethod &&
                                    <>
                                        <p className="bold">Ship Method:</p>
                                        <p>{shipMethod}</p>
                                    </>
                                }
                            </td>
                            {showPrice &&
                                <td className="text-right">
                                    <p>
                                        <span className="bold">Parts Subtotal:</span> {FormatCurrency(partsTotal)} <br />
                                        <span className="bold">Accessories Subtotal:</span> {FormatCurrency(accTotal)} <br />
                                        <span className="bold">Other Subtotal:</span> {FormatCurrency(otherTotal)} <br />
                                        <span className="bold">Est Freight:</span> {FormatCurrency(estFreight)} <br />
                                        <span className="bold">Est Handling:</span> {FormatCurrency(estHandling)} <br />
                                        <span className="bold">Est Special Fee:</span> {FormatCurrency(estSpecialFee)} <br />
                                    </p>
                                    <p className="bold">Total: {FormatCurrency(grandTotal)}</p>
                                </td>
                            }
                        </tr>
                    </tbody>
                </Table>
            }
        </div>
    )
});

export default PrintableOrder;